"use client";
import React, { Component } from "react";
import type { ICurrency } from "@aspen/model/index";
import { updateCoinList } from "@aspen/store";
import { fetchCoinList } from "@aspen/services/index";
import type { ConnectedProps } from "react-redux";
import { connect } from "react-redux";
import { isEmpty } from "lodash-es";
import { convertUSD2USDC } from "@aspen/libs/index";

const mapStateToProps = (state) => {
  const { coinList } = state.currencies;
  return {
    coinList // 所有币种、名称、icon等
  };
};
const mapDispatchToProps = () => {
  return {
    updateCoinList: (payload) => updateCoinList(payload)
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ICoinListPropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends ICoinListPropsFromRedux {
  [key: string]: any; // 保留any，HOC组件，父组件传过来的props可能是任何类型
}

export interface ICoinListPropsO {
  fetchAllCoinList: () => void;
  getCoinFullName: (coinCode: string) => string;
}

export const WithCoinList = (WrappedComponent) => {
  class WithCoinList extends Component<IProps> {
    fetchAllCoinList: () => void = async () => {
      fetchCoinList()
        .then((res) => {
          if (res?.code == "0" && !isEmpty(res?.data)) {
            this.props.updateCoinList({ coinList: res?.data });
          } else {
            // ignore
          }
        })
        .finally(() => {});
    };

    getCoinFullName: (coinCode: string) => string = (coinCode) => {
      const fullName = convertUSD2USDC(this.props?.coinList[coinCode]?.name) || "";
      return fullName;
    };

    render() {
      return (
        <>
          <WrappedComponent
            {...this.props}
            fetchAllCoinList={this.fetchAllCoinList}
            coinList={this.props.coinList}
            getCoinFullName={this.getCoinFullName}
          />
        </>
      );
    }
  }
  return connect(mapStateToProps, mapDispatchToProps())(WithCoinList);
};
